import { Comp_page_2_1 } from '../components';
import React,{useState,useEffect} from "react";
// Auto-generated page



export default function NewPage_2(props) {
<div>New Page      <Comp_page_2_1 />
    </div>;
}
